(function() {
    var toggle = function(val, $scope) {
        $('.js-main-header-body', $scope).toggleClass('mod-shadow', val);
    };

    $(document).ready(function() {
        $('#navbarNavDropdown')
            .on('show.bs.collapse', function() {
                toggle(true);
            })
            .on('hide.bs.collapse', function() {
                toggle(false);
            });
    });
})();
